// src/services/permissionsService.js

import { API_ENDPOINTS } from "../../config/api/apiCall";
import { callApi } from "../commonapicall/fetchdata";


export const fetchUserPermissions = async (userID) => {
    let requestBody = { userid: userID };

    return callApi(API_ENDPOINTS.USER_getUserModulePermissionsForRestiction, 'POST', { 'Content-Type': 'application/json' }, requestBody)
        .then(data => data)
        .catch(error => {
            console.error(error);
            return [];
        });
};
